export default {
  fields: {
    caterer_id: {
      readOnly: true,
    },
    established_date: {
      type: 'date',
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    }
  },
  relationships: {
    caterer: 'caterers',
    story_tags: 'story_tags',
    photos: 'photos',
  },
}
